import React, { useRef, useState, useCallback, useMemo, useEffect } from "react";
import {
    LayoutDashboard,
    TrendingUp,
    ShoppingCart,
    ScrollText,
    FilePlus,
    Repeat,
    FileText,
    ReceiptIndianRupee,
    FileMinus,
    Package,
    Layers,
    FolderTree,
    BookOpen,
    Users,
    Contact,
    Globe,
    FileStack,
    LayoutTemplate,
    Sparkles,
    LayoutGrid,
    Megaphone,
    Images,
    SlidersHorizontal,
    MousePointerClick,
    Star,
    Tag,
    Menu as MenuIcon,
    Image,
    Newspaper,
    PenLine,
    FolderOpen,
    MessageSquareQuote,
    Award,
    Wallet,
    Wallet2,
    UsersRound,
    Building2,
    ClipboardCheck,
    ListTodo,
    Settings,
    Truck,
    MapPin,
    Palette,
    Paintbrush,
    PanelBottom,
    PhoneCall,
    UserCog,
    LogOut,
    HelpCircle,
    Menu,
    PanelLeftClose,
    PanelLeftOpen,
    X,
    History,
    ChevronRight,
    ChevronDown,
    ChevronsUpDown,
    School,
    LayoutList,
    Ticket,
    Boxes,
    Link2,
    Server,
    Shield,
    CircleDot,
    BarChart3,
    CreditCard,
    Clock,
} from "lucide-react";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { getDecryptedUserFromCookie } from "./utils/getCookie";
import usermain from "../Img/user.png";
import sidebarLogo from "../Img/de.png";
import { usePermissions } from "../context/PermissionContext";
import { permissionForPath } from "../config/permissionMenuMap";
import { clearAdminSession } from "../modules/saas/utils/session";
import "./SideBar.css";

const isStaffUser = (u) => String(u?.type ?? "").toLowerCase() === "staff";

const staffMenuData = [
    { title: "Dashboard", icon: LayoutDashboard, path: "/dashboard", type: "link", permission: "dashboard.read" },
    { title: "Attendance", icon: ClipboardCheck, path: "/attendance", type: "link", permission: "attendance.read" },
    { title: "Tasks", icon: ListTodo, path: "/tasks", type: "link", permission: "tasks.read" },
    { title: "CRM", icon: Contact, path: "/crm", type: "link", permission: "crm.read" },
    { title: "Orders", icon: ShoppingCart, path: "/orders", type: "link", permission: "orders.read" },
];

const menuData = [
    { title: "Dashboard", icon: LayoutDashboard, path: "/dashboard", type: "link" },

    {
        title: "Sales",
        icon: TrendingUp,
        type: "accordion",
        groupStart: true,
        submenus: [
            { title: "Orders", icon: ShoppingCart, path: "/orders", type: "link", badgeKey: "orders" },
            { title: "Quotes", icon: ScrollText, path: "/quotes", type: "link" },
            { title: "New Quote", icon: FilePlus, path: "/new-quote", type: "link" },
            { title: "Auto-billing", icon: Repeat, path: "/recurring-invoices", type: "link" },
            { title: "Invoices", icon: FileText, path: "/invoice", type: "link" },
            { title: "Receipts", icon: ReceiptIndianRupee, path: "/receipt", type: "link" },
            { title: "Credit Notes", icon: FileMinus, path: "/credit-notes", type: "link" },
        ],
    },

    {
        title: "Products",
        icon: Package,
        type: "accordion",
        groupStart: true,
        submenus: [
            { title: "Products / Services", icon: Package, path: "/products", type: "link" },
            { title: "Grouped Products", icon: Boxes, path: "/grouped-product", type: "link" },
            { title: "Categories", icon: FolderTree, path: "/category", visibleFor: "Admin", type: "link" },
            { title: "Variations", icon: Layers, path: "/features", visibleFor: "Admin", type: "link" },
            { title: "Coupons", icon: Ticket, path: "/coupon", visibleFor: "Admin", type: "link" },
            {
                title: "Catalog",
                icon: BookOpen,
                type: "accordion",
                submenus: [
                    { title: "Catalog Categories", icon: FolderOpen, path: "/catlog-catgeory", visibleFor: "Admin", type: "link" },
                    { title: "Catalog", icon: LayoutList, path: "/catlog", visibleFor: "Admin", type: "link" },
                ],
            },
        ],
    },

    {
        title: "Customers",
        icon: Users,
        type: "accordion",
        groupStart: true,
        submenus: [
            { title: "Customers", icon: Users, path: "/customer", type: "link" },
            { title: "CRM", icon: Contact, path: "/crm", type: "link" },
            { title: "CRM Analytics", icon: Contact, path: "/crm-analytics", type: "link" },
        ],
    },

    {
        title: "Website / App",
        icon: Globe,
        type: "accordion",
        visibleFor: "Admin",
        groupStart: true,
        submenus: [
            {
                title: "Pages",
                icon: FileStack,
                type: "accordion",
                submenus: [
                    { title: "FAQ", icon: HelpCircle, path: "/faq", type: "link" },
                    { title: "Careers", icon: Users, path: "/career", type: "link" },
                    { title: "Jobs", icon: ListTodo, path: "/jobs", type: "link" },
                ],
            },
            {
                title: "Homepage Builder",
                icon: LayoutTemplate,
                type: "accordion",
                submenus: [
                    { title: "Hero Section", icon: Sparkles, path: "/herosection", type: "link" },
                    { title: "Home Sections", icon: LayoutGrid, path: "/newarrival", type: "link" },
                    { title: "CTA Sections", icon: Megaphone, path: "/headline", type: "link" },
                    { title: "Sliders", icon: Images, path: "/slider", type: "link" },
                    { title: "Track Page Sliders", icon: SlidersHorizontal, path: "/track-slider", type: "link" },
                    { title: "CTA 1", icon: MousePointerClick, path: "/calltoactionfirst", type: "link" },
                    { title: "CTA 2", icon: MousePointerClick, path: "/calltoactionsecond", type: "link" },
                    { title: "Reviews", icon: Star, path: "/review", type: "link" },
                    { title: "Offers", icon: Tag, path: "/offer", type: "link" },
                ],
            },
            { title: "Menus", icon: MenuIcon, path: "/menus", type: "link" },
            { title: "Media Library", icon: Image, path: "/media", type: "link" },
            {
                title: "Blog",
                icon: Newspaper,
                type: "accordion",
                submenus: [
                    { title: "Posts", icon: Newspaper, path: "/blog", type: "link" },
                    { title: "Add Blog", icon: PenLine, path: "/add-blog", type: "link" },
                    { title: "Categories", icon: FolderTree, path: "/blog-category", type: "link" },
                    { title: "Authors", icon: Users, path: "/author", type: "link" },
                    { title: "Comments", icon: MessageSquareQuote, path: "/comment", type: "link" },
                ],
            },
            { title: "Testimonials", icon: MessageSquareQuote, path: "/testimonial", type: "link" },
            { title: "Brand Assets", icon: Award, path: "/brand", type: "link" },
        ],
    },

    {
        title: "Finance",
        icon: Wallet,
        type: "accordion",
        visibleFor: "Admin",
        groupStart: true,
        submenus: [
            { title: "Expenses", icon: Wallet, path: "/expense", type: "link" },
            { title: "Wallet", icon: Wallet2, path: "/wallet-target", type: "link" },
        ],
    },

    {
        title: "Team",
        icon: UsersRound,
        type: "accordion",
        groupStart: true,
        submenus: [
            { title: "Departments", icon: Building2, path: "/departments", type: "link" },
            { title: "Team Directory", icon: UsersRound, path: "/team-directory", type: "link" },
            { title: "Attendance", icon: ClipboardCheck, path: "/team-attendance", type: "link" },
            { title: "Tasks", icon: ListTodo, path: "/tasks", type: "link" },
        ],
    },

    {
        title: "Students",
        icon: School,
        type: "accordion",
        visibleFor: "Admin",
        visibleSk: "Skates",
        groupStart: true,
        submenus: [
            { title: "Admission", icon: School, path: "/admission", type: "link" },
            { title: "Form Builder", icon: PenLine, path: "/admission-form-builder", type: "link" },
            { title: "Admission Plans", icon: Tag, path: "/admission-plans", type: "link" },
            { title: "Attendance", icon: ClipboardCheck, path: "/student-attendance", type: "link" },
            { title: "Batches", icon: LayoutGrid, path: "/admission-batches", type: "link" },
            { title: "Centers", icon: Building2, path: "/admission-centers-settings", type: "link" },
        ],
    },

    {
        title: "Platform",
        icon: Shield,
        type: "accordion",
        visibleFor: "SuperAdmin",
        groupStart: true,
        submenus: [
            { title: "Category", icon: Layers, path: "/category-main", type: "link" },
            { title: "All User Records", icon: Users, path: "/alluser-records", type: "link" },
            { title: "CORS Access URLs", icon: Link2, path: "/cors-origins", type: "link" },
            { title: "Theme Management", icon: Palette, path: "/theme-management", type: "link" },
            { title: "Site Provisioning", icon: Server, path: "/provisioning", type: "link" },
            { title: "Plans", icon: Layers, path: "/plan", type: "link" },
            { title: "SaaS Companies", icon: Building2, path: "/saas/super/companies", type: "link" },
            { title: "SaaS Plans", icon: Tag, path: "/saas/super/plans", type: "link" },
            { title: "SaaS Revenue", icon: BarChart3, path: "/saas/super/revenue", type: "link" },
            { title: "SaaS Subscriptions", icon: CreditCard, path: "/saas/super/subscriptions", type: "link" },
            { title: "SaaS Trials", icon: Clock, path: "/saas/super/trials", type: "link" },
            { title: "SaaS Payments", icon: Wallet, path: "/saas/super/payments", type: "link" },
        ],
    },

    {
        title: "Settings",
        icon: Settings,
        type: "accordion",
        visibleFor: "Admin",
        groupStart: true,
        submenus: [
            { title: "Subscription", icon: CreditCard, path: "/saas/subscription", type: "link" },
            { title: "Trial Status", icon: Clock, path: "/saas/trial", type: "link" },
            { title: "Delivery Settings", icon: Truck, path: "/delivery", type: "link" },
            { title: "Pincode Settings", icon: MapPin, path: "/pincode", type: "link" },
            { title: "Themes", icon: Palette, path: "/appearance/themes", type: "link" },
            { title: "Appearance", icon: Paintbrush, path: "/appearance/customize", type: "link" },
            { title: "Footer Settings", icon: PanelBottom, path: "/footer-setting", type: "link" },
            { title: "Request Callback", icon: PhoneCall, path: "/calltoaction-form", type: "link" },
            { title: "Users", icon: UserCog, path: "/user-records", type: "link" },
            { title: "Google Ads", icon: Megaphone, path: "/integrations", type: "link" },
        ],
    },
];

const Sidebar = ({
    collapsed,
    setCollapsed,
    mobileOpen,
    setMobileOpen,
    isMobile,
    isTablet,
    onCloseMobile,
    totalnewOrder,
}) => {
    const [openAccordions, setOpenAccordions] = useState({});
    const [tooltip, setTooltip] = useState(null);
    const dropdownRef = useRef(null);
    const sidebarRef = useRef(null);
    const user = getDecryptedUserFromCookie();
    const userType = user?.type;
    const userCategory = user?.category;
    const { isStaff, hasPermission } = usePermissions();
    const navigate = useNavigate();
    const location = useLocation();

    const isPathActive = useCallback(
        (path) => {
            if (!path) return false;
            const p = location.pathname;
            if (path === "/") return p === "/";
            if (path === "/attendance") {
                return p === "/attendance" || p === "/student-attendance" || p.startsWith("/student-attendance/");
            }
            return p === path || p.startsWith(path + "/");
        },
        [location.pathname]
    );

    const hasActiveDescendant = useCallback(
        (item) => {
            if (!item?.submenus?.length) return false;
            return item.submenus.some((sub) => {
                if (sub.type === "link" && sub.path) return isPathActive(sub.path);
                if (sub.type === "accordion") return hasActiveDescendant(sub);
                return false;
            });
        },
        [isPathActive]
    );

    const toggleAccordion = (id) => {
        setOpenAccordions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const handleAccordionClick = (id) => {
        if (collapsed && !isMobile && !isTablet) {
            setCollapsed(false);
            setOpenAccordions((prev) => ({ ...prev, [id]: true }));
            return;
        }
        toggleAccordion(id);
    };

    const handleCollapse = () => {
        setOpenAccordions({});
        setCollapsed(true);
    };

    const handleSidebarMouseEnter = () => {
        if (isMobile || isTablet) return;
        hideTooltip();
        setCollapsed(false);
    };

    const handleSidebarMouseLeave = () => {
        if (isMobile || isTablet) return;
        hideTooltip();
        setCollapsed(true);
    };

    const showTooltip = (e, title) => {
        if (!collapsed || isMobile || isTablet) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            title,
            top: rect.top + rect.height / 2,
        });
    };

    const hideTooltip = () => setTooltip(null);

    const applyBadges = (items) =>
        items.map((item) => {
            if (!item.submenus) return item;
            return {
                ...item,
                submenus: item.submenus.map((sub) => {
                    const withChildren = sub.submenus
                        ? { ...sub, submenus: applyBadges(sub.submenus) }
                        : sub;
                    if (withChildren.badgeKey === "orders" && totalnewOrder > 0) {
                        return { ...withChildren, badge: String(totalnewOrder) };
                    }
                    return withChildren;
                }),
            };
        });

    const dynamicMenuData = useMemo(() => {
        const base = isStaffUser(user) ? staffMenuData : menuData;
        return applyBadges(base);
    }, [totalnewOrder, user]);

    const handlelogout = async () => {
        try {
            clearAdminSession();
            navigate("/login", { replace: true });
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };

    const filterMenuTree = useCallback(
        (items) =>
            items
                .filter((item) => {
                    if (item.hidden) return false;
                    const userTypeMatches = !item.visibleFor || item.visibleFor === userType;
                    const normSk = (s) => String(s ?? "").trim().toLowerCase().replace(/\s+/g, " ");
                    const catNorm = normSk(userCategory);
                    const need = normSk(item.visibleSk);
                    const visibleSkMatches =
                        !item.visibleSk ||
                        catNorm === need ||
                        (need === "skates" && catNorm.includes("skates"));
                    const permSlug =
                        item.permission ||
                        (item.path ? permissionForPath(item.path) : null);
                    const permissionMatches =
                        !isStaff || !permSlug || hasPermission(permSlug);
                    return userTypeMatches && visibleSkMatches && permissionMatches;
                })
                .map((item) => {
                    if (item.submenus) {
                        const filteredSubNav = filterMenuTree(item.submenus).filter(
                            (sub) => !sub.visibleFor || sub.visibleFor === userType
                        );
                        return { ...item, submenus: filteredSubNav };
                    }
                    return item;
                })
                .filter((item) => item.type === "link" || !item.submenus || item.submenus.length > 0),
        [userType, userCategory, isStaff, hasPermission]
    );

    const filteredNavItems = useMemo(
        () => filterMenuTree(dynamicMenuData),
        [dynamicMenuData, filterMenuTree]
    );

    useEffect(() => {
        const p = location.pathname;
        const pathActive = (path) => {
            if (!path) return false;
            if (path === "/") return p === "/";
            if (path === "/attendance") {
                return p === "/attendance" || p === "/student-attendance" || p.startsWith("/student-attendance/");
            }
            return p === path || p.startsWith(path + "/");
        };
        const subtreeActive = (sub) => {
            if (sub.type === "link" && sub.path) return pathActive(sub.path);
            if (sub.type === "accordion" && sub.submenus?.length) return sub.submenus.some(subtreeActive);
            return false;
        };
        const toOpen = {};
        const walk = (items, parentId = "") => {
            for (const item of items) {
                const id = `${parentId}-${item.title}`;
                if (item.type === "accordion" && item.submenus?.length) {
                    if (item.submenus.some(subtreeActive)) toOpen[id] = true;
                    walk(item.submenus, id);
                }
            }
        };
        walk(filteredNavItems);
        setOpenAccordions((prev) => ({ ...prev, ...toOpen }));
    }, [location.pathname, filteredNavItems]);

    const showExpanded = !collapsed || isMobile || isTablet;

    const renderIcon = (Icon, isActive, depth) => {
        if (!Icon) {
            return depth > 0 ? <CircleDot className="app-sidebar__dot" strokeWidth={2.5} /> : null;
        }
        return (
            <span className={`app-sidebar__icon-box${isActive ? " app-sidebar__icon-box--active" : ""}`}>
                <Icon className="app-sidebar__glyph" strokeWidth={2} />
            </span>
        );
    };

    const renderMenuItem = (item, parentId = "", depth = 0) => {
        const itemId = `${parentId}-${item.title}`;

        const isOpen = openAccordions[itemId];
        const Icon = item.icon;
        const childActive = item.type === "accordion" && hasActiveDescendant(item);
        const linkActive = item.type === "link" && item.path && isPathActive(item.path);
        const isActive = Boolean(linkActive || childActive);

        const linkClass = [
            "app-sidebar__link",
            isActive ? "app-sidebar__link--active" : "",
            collapsed && !isMobile && !isTablet ? "app-sidebar__link--collapsed" : "",
            item.type === "accordion" && isOpen ? "app-sidebar__link--accordion-open" : "",
            depth > 0 ? "app-sidebar__link--depth" : "",
            depth > 1 ? "app-sidebar__link--depth-deep" : "",
            item.groupStart && depth === 0 ? "app-sidebar__link--group-start" : "",
        ]
            .filter(Boolean)
            .join(" ");

        const listItemClass = item.groupStart && depth === 0 ? "app-sidebar__group" : "";

        const linkBody = (
            <>
                {renderIcon(Icon, isActive, depth)}
                {showExpanded && (
                    <>
                        <span className="app-sidebar__label">{item.title}</span>
                        {item.badge && <span className="app-sidebar__badge">{item.badge}</span>}
                        {item.type === "accordion" && (
                            <span className="app-sidebar__chevron" aria-hidden>
                                {isOpen ? (
                                    <ChevronDown className="size-4" strokeWidth={2} />
                                ) : (
                                    <ChevronRight className="size-4" strokeWidth={2} />
                                )}
                            </span>
                        )}
                    </>
                )}
            </>
        );

        if (item.type === "link") {
            return (
                <li key={itemId} className={listItemClass}>
                    <NavLink
                        to={item.path}
                        end={item.path === "/"}
                        onClick={() => (isMobile || isTablet) && onCloseMobile()}
                        onMouseEnter={(e) => showTooltip(e, item.title)}
                        onMouseLeave={hideTooltip}
                        className={linkClass}
                    >
                        {linkBody}
                    </NavLink>
                </li>
            );
        }

        const panelOpen = isOpen && showExpanded;

        return (
            <li key={itemId} className={listItemClass}>
                <button
                    type="button"
                    onClick={() => handleAccordionClick(itemId)}
                    onMouseEnter={(e) => showTooltip(e, item.title)}
                    onMouseLeave={hideTooltip}
                    className={linkClass}
                    aria-expanded={panelOpen}
                >
                    {linkBody}
                </button>
                <div className={`app-sidebar__accordion-panel${panelOpen ? " is-open" : ""}`}>
                    <ul className={`app-sidebar__sublist${depth === 0 ? " app-sidebar__sublist--root" : ""}`}>
                        {item.submenus?.map((sub) => renderMenuItem(sub, itemId, depth + 1))}
                    </ul>
                </div>
            </li>
        );
    };

    const isOverlay = isMobile || isTablet;
    const sidebarWidthClass = isOverlay
        ? mobileOpen
            ? "app-sidebar--open-overlay"
            : "app-sidebar--closed-overlay"
        : collapsed
            ? "app-sidebar--collapsed"
            : "app-sidebar--expanded";

    return (
        <>
            <div
                ref={sidebarRef}
                className={`app-sidebar ${sidebarWidthClass}${isOverlay && mobileOpen ? " app-sidebar--overlay-visible" : ""}`}
                onMouseEnter={handleSidebarMouseEnter}
                onMouseLeave={handleSidebarMouseLeave}
            >
                <div className="app-sidebar__glow" aria-hidden />

                <header
                    className={`app-sidebar__header${collapsed && !isOverlay ? " app-sidebar__header--collapsed-desktop" : ""}`}
                >
                    {collapsed && !isOverlay ? (
                        <>
                            <div
                                role="button"
                                tabIndex={0}
                                onClick={() => navigate("/dashboard")}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        navigate("/dashboard");
                                    }
                                }}
                                className="app-sidebar__logo app-sidebar__logo--compact"
                            >
                                <img src={sidebarLogo} alt="Beentara" />
                            </div>
                            <button
                                type="button"
                                onClick={() => setCollapsed(false)}
                                className="app-sidebar__icon-btn"
                                aria-label="Expand sidebar"
                            >
                                <PanelLeftOpen className="size-5" strokeWidth={2} />
                            </button>
                        </>
                    ) : (
                        <>
                            <div className="app-sidebar__brand">
                                <div
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => {
                                        navigate("/dashboard");
                                        if (isOverlay) onCloseMobile();
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            navigate("/dashboard");
                                            if (isOverlay) onCloseMobile();
                                        }
                                    }}
                                    className="app-sidebar__logo"
                                >
                                    <img src={sidebarLogo} alt="Beentara" />
                                </div>
                                <div className="app-sidebar__brand-text">
                                    <span className="app-sidebar__brand-name">Beentara</span>
                                    <span className="app-sidebar__brand-tag">Built for growth</span>
                                </div>
                            </div>
                            {!isOverlay ? (
                                <button
                                    type="button"
                                    onClick={handleCollapse}
                                    className="app-sidebar__icon-btn"
                                    aria-label="Collapse sidebar"
                                >
                                    <PanelLeftClose className="size-5" strokeWidth={2} />
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    onClick={onCloseMobile}
                                    className="app-sidebar__icon-btn"
                                    aria-label="Close menu"
                                >
                                    <X className="size-5" strokeWidth={2} />
                                </button>
                            )}
                        </>
                    )}
                </header>

                <nav className="app-sidebar__nav" aria-label="Main">
                    <ul className="app-sidebar__list">
                        {filteredNavItems.map((i) => renderMenuItem(i))}
                    </ul>
                </nav>

                <footer className="app-sidebar__footer">
                    <UserDropdown
                        collapsed={collapsed}
                        setCollapsed={setCollapsed}
                        isOverlay={isOverlay}
                        navigate={navigate}
                        dropdownRef={dropdownRef}
                        user={user}
                        handlelogout={handlelogout}
                        isStaff={isStaffUser(user)}
                    />
                </footer>
            </div>

            {tooltip && collapsed && !isOverlay && (
                <div
                    className="app-sidebar__tooltip whitespace-nowrap"
                    style={{
                        left: sidebarRef.current?.getBoundingClientRect().right + 10,
                        top: tooltip.top,
                        transform: "translateY(-50%)",
                    }}
                >
                    {tooltip.title}
                </div>
            )}

            {isOverlay && !mobileOpen && (
                <div className="app-sidebar__mobile-bar">
                    <button
                        type="button"
                        className="app-sidebar__mobile-icon-btn app-sidebar__mobile-icon-btn--primary"
                        onClick={() => setMobileOpen(true)}
                        aria-label="Open menu"
                    >
                        <Menu className="size-6" strokeWidth={2} />
                    </button>
                    <div className="app-sidebar__mobile-bar-actions">
                        <button
                            type="button"
                            className="app-sidebar__mobile-icon-btn"
                            onClick={() => navigate("/dashboard")}
                            aria-label="Dashboard"
                        >
                            <LayoutDashboard className="size-5" strokeWidth={2} />
                        </button>
                        <button
                            type="button"
                            className="app-sidebar__mobile-icon-btn"
                            onClick={() => navigate("/history")}
                            aria-label="History"
                        >
                            <History className="size-5" strokeWidth={2} />
                        </button>
                        <button
                            type="button"
                            className="app-sidebar__mobile-avatar"
                            onClick={() => setMobileOpen(true)}
                            aria-label="Account menu"
                        >
                            <img src={usermain} alt="" />
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

const UserDropdown = ({
    collapsed,
    setCollapsed,
    isOverlay,
    navigate,
    dropdownRef,
    user,
    handlelogout,
    isStaff,
}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [tooltip, setTooltip] = useState(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        if (collapsed && !isOverlay) {
            setDropdownOpen(false);
        }
    }, [collapsed, isOverlay]);

    const showTooltip = (e, text) => {
        if (!collapsed || isOverlay) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            text,
            top: rect.top + rect.height / 2,
            left: rect.right + 8,
        });
    };

    const hideTooltip = () => setTooltip(null);

    const menuItems = [
        ...(!isStaff ? [{ icon: Settings, text: "Settings", onClick: () => navigate("/setting") }] : []),
        { icon: HelpCircle, text: "Help & Support", onClick: () => navigate("/help-support") },
        { icon: LogOut, text: "Sign out", onClick: handlelogout },
    ];

    const showExpanded = !collapsed || isOverlay;

    return (
        <div ref={dropdownRef} className="relative">
            <button
                type="button"
                ref={buttonRef}
                onClick={() => {
                    if (collapsed && !isOverlay) {
                        setCollapsed(false);
                        setDropdownOpen(true);
                        return;
                    }
                    setDropdownOpen((o) => !o);
                }}
                onMouseEnter={(e) => showTooltip(e, user?.full_name || "User")}
                onMouseLeave={hideTooltip}
                className={`app-sidebar__user-btn${collapsed && !isOverlay ? " app-sidebar__user-btn--collapsed" : ""}`}
            >
                <img className="app-sidebar__user-avatar" src={usermain} alt="" />
                {showExpanded && (
                    <div className="app-sidebar__user-text">
                        <p className="app-sidebar__user-name">{user?.full_name || "User"}</p>
                        <p className="app-sidebar__user-email">{user?.email || ""}</p>
                    </div>
                )}
                {showExpanded && (
                    <ChevronsUpDown
                        className={`app-sidebar__user-chevron${dropdownOpen ? " app-sidebar__user-chevron--open" : ""}`}
                    />
                )}
            </button>

            <div
                className={`app-sidebar__dropdown${collapsed && !isOverlay ? " app-sidebar__dropdown--collapsed" : ""} ${
                    dropdownOpen
                        ? "opacity-100 visible translate-y-0"
                        : "opacity-0 invisible translate-y-1 pointer-events-none"
                }`}
            >
                {menuItems.map((item, idx) => {
                    const Icon = item.icon;
                    return (
                        <button
                            type="button"
                            key={idx}
                            onClick={() => {
                                item.onClick();
                                setDropdownOpen(false);
                            }}
                            onMouseEnter={(e) => showTooltip(e, item.text)}
                            onMouseLeave={hideTooltip}
                            className="app-sidebar__dropdown-item"
                        >
                            <Icon className="app-sidebar__glyph" strokeWidth={2} />
                            {showExpanded && <span>{item.text}</span>}
                        </button>
                    );
                })}
            </div>

            {tooltip && collapsed && !isOverlay && (
                <div
                    className="app-sidebar__tooltip whitespace-nowrap"
                    style={{
                        left: tooltip.left,
                        top: tooltip.top,
                        transform: "translateY(-50%)",
                    }}
                >
                    {tooltip.text}
                </div>
            )}
        </div>
    );
};

export default Sidebar;
